import { render, staticRenderFns } from "./Drills.vue?vue&type=template&id=b1791f50"
import script from "./Drills.vue?vue&type=script&lang=js"
export * from "./Drills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports